import { AbstractControl, ValidatorFn } from '@angular/forms';

export const setFormControlValidators = (fc: AbstractControl, validators: ValidatorFn[]) => {
  fc.clearValidators();
  fc.setValidators(validators);
  fc.updateValueAndValidity({ emitEvent: false });
};
